import {connect} from "react-redux"
import {State} from "../../ducks"
import {createRecentQuery} from "../../ducks/recents"
import {search, getPlpUrl} from "../../ducks/search"

export const mapStateToProps = (state: State) => ({
    suggestions: state.autocomplete.suggestions,
    term: state.search.typedCharacters,
    siteUrl: state.request.siteUrl,
    cleanSiteUrl: state.request.cleanSiteUrl,
    isTpSuperLite: state.settings.isTpSuperLite,
    showSelectionHighlight: state.settings.isAutoSuggestHighlightEnabled,
    autocompleteMaxItems: state.settings.autocompleteMaxItems,
    templating: state.template,
})

export const mapDispatchToProps = (dispatch, ownProps) => ({
    handleSuggestionClick: (suggestion: string, siteUrl: string) => {
        const {isTpSuperLite, cleanSiteUrl} = ownProps
        dispatch(createRecentQuery(suggestion))
        dispatch(search(isTpSuperLite ? cleanSiteUrl : siteUrl, suggestion))
    },
    getConnectedPlpUrl: (suggestion: string, siteUrl: string) => getPlpUrl(siteUrl)(suggestion),
})

export default connect(mapStateToProps, mapDispatchToProps)
